import { data } from 'jquery';
import { Component, OnInit, Input } from "@angular/core";
import { NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: "app-view-address",
  templateUrl: "./view-address.component.html",
  styles: [],
})
export class ViewAddressComponent implements OnInit {
  @Input() addressInfo: any;
  viewAddress = "";
  loader = false;

  constructor(
    public dialogRef: NgbActiveModal,
  ) {}

  ngOnInit(): void {
   this.viewAddress = this.addressInfo.data
  }

  

  close() {
    this.dialogRef.close({ success: false });
  }
  
}
